import { Options } from "vue-class-component";
import BaseTableInterface from "@/mixins/BaseTableInterface";
import BaseTableMixins from "@/mixins/BaseTable";
import SelectLevel from "@/modules/select-level/select-level.vue";
import DraggableListview from "@/modules/draggable-listview/draggable-listview.vue";
import BusinessTableItem from "@/entity/aftersale/ticket/BusinessTableItem";
import API from "@/api/aftersale/ticket/business";

@Options({
    name: "app-aftersale-ticket-business",
    components: {
        "app-select-level": SelectLevel,
        "app-draggable-listview": DraggableListview,
    },
})
export default class Business extends BaseTableMixins<BusinessTableItem> implements Partial<BaseTableInterface<BusinessTableItem>> {
    public created(): void {
        this.setInterface(this);
        this.tableRequestItem.lockItem = this.getLockItem();
        this.editTableItem = new BusinessTableItem();
        this.editModalItem = new BusinessTableItem();
    }

    //锁定列数据实体
    public getLockItem(): any {
        return {
            businessParentId: {
                type: "router",
                name: "business_id",
                title: "上级故障类型",
                parent: -1,
                value: null,
                openFn: this.businessParentIdLevelModalOpen,
            },
        };
    }

    public activated(): void {
        this.getList(1);
    }

    //后端API
    public getApi(): any {
        return API;
    }

    // //列表回调
    // public listCallback(items: Array<BusinessTableItem>): void {
    //     return;
    // }

    //添加弹窗配置
    public addModalSetting(): void {
        this.editTableItem = new BusinessTableItem();
        this.editModalItem = new BusinessTableItem();
        this.editModalItem.businessStatus = 1;
        this.editModalTitle = "添加故障类型";
        this.editModalSubmitButtonName = "添加";
    }
    //添加提交检测
    public addSubmitChecking(): string {
        if (this.$tools.isEmpty(this.editModalItem.businessName)) return "故障类型名称不能为空！";
        if (this.$tools.isEmpty(this.editModalItem.businessStatus)) return "故障类型状态不能为空！";
        if (this.$tools.isEmpty(this.editModalItem.businessParentId)) return "上级故障类型不能为空！";
        return null;
    }
    // //添加回调
    // public addModalCallback(res: any): void {
    //     return;
    // }

    //修改弹窗配置
    public modModalSetting(): void {
        this.editModalTitle = "修改故障类型 (" + this.editModalItem.businessName + ")";
        this.editModalSubmitButtonName = "修改";
    }
    //修改提交检测
    public modSubmitChecking(): string {
        if (this.$tools.isEmpty(this.editModalItem.businessId)) return "故障类型ID不能为空！";
        return this.addSubmitChecking();
    }
    // //修改回调
    // public modModalCallback(res: any): void {
    //     return;
    // }

    //删除提示框配置
    public delAlertConfig(): any {
        return {
            type: "okAndNo",
            title: "删除故障类型",
            message: "故障类型: " + this.editModalItem.businessName + "<br>请确认删除？",
        };
    }
    // //删除提示框配置
    // public delAlertSetting(): void {
    //     return;
    // }
    //删除提示框提交检测
    public delSubmitChecking(): string {
        if (this.$tools.isEmpty(this.editModalItem.businessId)) return "故障类型ID不能为空！";
        return null;
    }
    // //删除回调
    // public delAlertCallback(res: any): void {
    //     return;
    // }

    //状态提示框配置
    public statusAlertConfig(): any {
        return {
            title: "故障类型状态",
            message: "故障类型: " + this.editModalItem.businessName + "<br>请确认修改状态？",
            submitButtonName: this.editModalItem.businessStatus === 1 ? "启用" : "禁用",
        };
    }
    //状态切换请求配置
    public toggleStatusSetting(): void {
        this.editModalItem.businessStatus = this.editModalItem.businessStatus === 1 ? 2 : 1;
    }
    //状态切换提交检测
    public toggleStatusSubmitChecking(): string {
        if (this.$tools.isEmpty(this.editModalItem.businessId)) return "故障类型ID不能为空！";
        return null;
    }
    // //状态切换回调
    // public toggleStatusCallback(): void {
    //     return;
    // }

    //排序弹窗配置
    public sortModalSetting(): void {
        this.editSortBaseTitle = "故障类型排序";
    }
    //排序提交检测
    public sortSubmitChecking(): string {
        if (this.editModalItem.businessParentId < -1) {
            this.toast.error("上级ID不能小余-1");
            return;
        }
        return null;
    }

    //businessParentId搜索字段
    private businessParentIdLevelSearchField: any = [
        { field: "business_name", name: "名称" },
        { field: "business_remark", name: "说明" },
    ];
    //businessParentId层级选择器打开
    public businessParentIdLevelModalOpen() {
        (this.$refs.businessParentIdLevel as any).openModal();
    }
    //businessParentId层级选择器提交
    public async businessParentIdLevelFunction(item: any): Promise<void> {
        const curItem = this.$tools.isEmpty(item.value) ? this.getLockItem().businessParentId : item;
        this.tableRequestItem.lockItem.businessParentId.value = curItem.value;
        this.tableRequestItem.lockItem.businessParentId.title = curItem.title;
        this.tableRequestItem.lockItem.businessParentId.parent = curItem.parent;
        await this.getList(1);
        return Promise.resolve();
    }

    get businessParentIdSelectApi() {
        return {
            api: (query: any) => API.idSelect(query),
            parent: "business_parent_id",
            status: "business_status",
            name: "business_name",
            id: "business_id",
            cid: this.editModalItem.businessParentId,
            mid: this.editModalItem.businessId,
            extend: true,
        };
    }
}
